(function () {
  // Build lightbox DOM once
  const lightbox = document.createElement('div');
  lightbox.className = 'swatch-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.innerHTML = `
    <div class="swatch-lightbox__inner">
      <button class="swatch-lightbox__close" aria-label="Close">&#x2715;</button>
      <img class="swatch-lightbox__image" src="" alt="">
      <p class="swatch-lightbox__name"></p>
    </div>
  `;
  document.body.appendChild(lightbox);

  const img = lightbox.querySelector('.swatch-lightbox__image');
  const name = lightbox.querySelector('.swatch-lightbox__name');
  const inner = lightbox.querySelector('.swatch-lightbox__inner');
  const closeBtn = lightbox.querySelector('.swatch-lightbox__close');

  function openLightbox(imageUrl, colorName) {
    img.src = imageUrl;
    img.alt = colorName;
    name.textContent = colorName;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close on backdrop click
  lightbox.addEventListener('click', function (e) {
    if (!inner.contains(e.target)) closeLightbox();
  });

  // Close on X button
  closeBtn.addEventListener('click', closeLightbox);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  // Delegate click on swatch labels
  document.addEventListener('click', function (e) {
    const label = e.target.closest('[data-swatch-image]');
    if (!label) return;
    openLightbox(label.dataset.swatchImage, label.dataset.swatchName);
  });
})();